//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DiagrammingLibraryAuthor.js";
import "../no/TaggedObject.js";
let d=[[],[[["classId"],"SelectFolder",{},1,0],[["symbolId"],"SelectPipeStock",{},1,0],[["num_objects","pipeStockObjects"],"GetPipeStockObjects",{},0,0],[["instanceId","partId","partName","numberName"],"CreatePipeStock",{R_:{pipeStockObject:"DiagrammingLibraryAuthor.AttributeHolder"}},4,0],[["pipeStockObject"],"DeletePipeStock",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.DiagrammingLibraryAuthor.PipeStockBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DiagrammingLibraryAuthor.PipeStockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;